<template>
    <div class="volunteer-registration">
        <div class="page-banner">
            <img src="/image/vole.png" alt="志愿者报名">
        </div>
        <div class="form-wrap">
            <el-form
                ref="formRef"
                :model="form"
                :rules="rules"
                label-width="50px"
                label-position="left"
                class="registration-form"
            >
                <el-form-item label="姓名" prop="name">
                    <el-input v-model.trim="form.name" class="small-input"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model.trim="form.phone" class="small-input" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="自我介绍" prop="introduction" class="intro-item">
                    <el-input
                        v-model.trim="form.introduction"
                        type="textarea"
                        resize="none"
                        placeholder="请填写"
                        class="intro-input"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="submit-btn" type="primary" @click="handleSubmit">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { Message } from 'element-ui';

const formRef = ref(null);
const form = reactive({
    name: '',
    phone: '',
    introduction: ''
});

const validatePhone = (rule, value, callback) => {
    if (!value) {
        callback(new Error('请输入手机号'));
        return;
    }

    if (!/^1\d{10}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
        return;
    }

    callback();
};

const rules = {
    name: [
        { required: true, message: '请输入姓名', trigger: 'blur' }
    ],
    phone: [
        { required: true, validator: validatePhone, trigger: 'blur' }
    ],
    introduction: [
        { message: '最多输入1000字', trigger: 'blur', max: 10 }
    ]
};

const handleSubmit = () => {
    formRef.value.validate((valid) => {
        if (!valid) {
            return;
        }

        Message.success('提交成功');
        formRef.value.resetFields();
    });
};
</script>

<style scoped lang="scss">
.volunteer-registration {
    min-height: 680px;
    background: #eeeeee;

    .page-banner {
        img {
            width: 100%;
            height: 273px;
        }
    }

    .form-wrap {
        width: 859px;
        min-height: 425px;
        margin: 31px auto 135px;
        padding: 87px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #dddddd;
    }

    .registration-form {
        ::v-deep .el-form-item {
            margin-bottom: 14px;
        }

        ::v-deep .el-form-item__label {
            color: #666666;
            font-size: 14px;
            line-height: 28px;
            padding-right: 18px;
        }

        ::v-deep .el-form-item__content {
            line-height: 28px;
        }

        ::v-deep .el-form-item__error {
            padding-top: 2px;
        }

        ::v-deep .el-input__inner {
            height: 24px;
            line-height: 24px;
            border-radius: 0;
            border-color: #d6d6d6;
            padding: 0 8px;
        }

        ::v-deep .el-textarea__inner {
            height: 182px;
            border-radius: 0;
            border-color: #d6d6d6;
            color: #666666;
            font-size: 14px;
        }

        .small-input {
            width: 262px;
        }

        .intro-item {
            margin-top: 23px;

            ::v-deep .el-form-item__label {
                float: none;
                display: block;
                width: auto !important;
                text-align: left;
                padding: 0;
                margin-bottom: 10px;
            }

            ::v-deep .el-form-item__content {
                margin-left: 0 !important;
            }
        }

        .intro-input {
            width: 100%;
        }

        .submit-btn {
            width: 105px;
            height: 30px;
            padding: 0;
            margin-top: 2px;
            border: none;
            border-radius: 0;
            background: #1f9295;
            color: #ffffff;
            font-size: 14px;

            &:hover,
            &:focus {
                background: #197f82;
            }
        }
    }
}
</style>
